import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie',
  imports: [],
  templateUrl: './cookie.html',
  styleUrl: './cookie.scss',
})
export class Cookie implements OnInit {
  ngOnInit(): void {
    this.getCookie();
  }

  getCookie() {
    if (typeof document !== 'undefined') {
      const bannerCookie = document.getElementById('policy-cookies');
      if (!localStorage.getItem('cookies-accepted')) {
        bannerCookie!.classList.add('active');
      }
    }
  }
  acceptCookies() {
    if (typeof document !== 'undefined') {
      const bannerCookie = document.getElementById('policy-cookies');
      localStorage.setItem('cookies-accepted', 'true');
      bannerCookie!.classList.remove('active');
    }
  }
}
